"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const getAtomsFromMF_1 = __importDefault(require("../../data/utilities/getAtomsFromMF"));
const inputStyle = (0, react_1.css) `
  text-align: center;

  input {
    height: 100%;
    width: 200px;
    border-radius: 5px;
    border: 0.55px solid #c7c7c7;
    margin: 0 5px;
    text-align: center;
  }

  button {
    flex: 2;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 5px;
    height: 36px;
    margin: 0 auto;
    margin-top: 15px;
    display: block;
    width: 20%;
    color: white;
    background-color: gray;
  }
`;
function isValidMf(mf) {
    if (mf.trim().length === 0) {
        return false;
    }
    try {
        (0, getAtomsFromMF_1.default)(mf);
        return true;
    }
    catch {
        return false;
    }
}
function MolecularFormulaInput({ onSave = () => null, previousMF, }) {
    const [mf, setMF] = (0, react_2.useState)('');
    const [isValidMF, setIsValidMF] = (0, react_2.useState)(true);
    const [hasChanged, setHasChanged] = (0, react_2.useState)(false);
    const onChangeHandler = (0, react_2.useCallback)((e) => {
        setHasChanged(true);
        if (isValidMf(e.target.value)) {
            setIsValidMF(true);
            setMF(e.target.value);
        }
        else {
            setIsValidMF(false);
            setMF('');
        }
    }, []);
    const onSaveHandler = (0, react_2.useCallback)(() => {
        onSave(hasChanged ? mf.trim() : previousMF);
    }, [hasChanged, mf, onSave, previousMF]);
    return ((0, jsx_runtime_1.jsxs)("div", { css: inputStyle, children: [(0, jsx_runtime_1.jsx)("input", { type: "text", onChange: onChangeHandler, defaultValue: previousMF }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onSaveHandler, disabled: !isValidMF, children: isValidMF ? 'Set' : 'Invalid' })] }));
}
exports.default = MolecularFormulaInput;
